/**
* Sets up a mutation observer to handle accessibility attributes when the timeout dialog appears/disappears.
* This ensures screen reader users can only focus on the timeout dialog when it's active.
* 
* The observer:
* - Sets aria-hidden="true" on the main content when dialog appears
* - Removes aria-hidden from main content when dialog closes
* - Watches for changes to document.body and its descendants
* 
* @example
* // Initialize the timeout dialog observer
* timeoutRefocus();
*/
export function timeoutRefocus() {
  const timeoutDialogMeta = document.querySelector('meta[name="hmrc-timeout-dialog"]')

  if (timeoutDialogMeta) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const timeoutDialog = document.getElementById('hmrc-timeout-dialog')
        const headingBody = document.getElementById('heading-body')

        if (timeoutDialog && mutation.addedNodes.length) {
          headingBody.setAttribute('aria-hidden', 'true')
        } else if (!timeoutDialog && mutation.removedNodes.length) {
          headingBody.removeAttribute('aria-hidden')
        }
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }
}